import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/WarrantyTable.jsx';

export default define`Roofing Warranty Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/WarrantyTable`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
